import { Group } from '@calendly/ui/components/menu'
import { useDispatch, useSelector } from 'react-redux'

import { loadMoreData } from 'actions/home_bar/scope_dropdown'
import { encodeScopeValue } from 'components/home_bar/scope_dropdown/scope_values'
import {
  filterTermSelector,
  hasMoreUserGroupsSelector,
  isFilteringSelector,
  userGroupsWhereAdminSelector
} from 'selectors/home_bar'

import Header from './header'
import Item from './item'
import ShowMore from './show_more'

const UserGroupsList = ({ canCreateNewGroups }) => {
  const dispatch = useDispatch()
  const isFiltering = useSelector(isFilteringSelector)
  const filterTerm = useSelector(filterTermSelector)
  const userGroupsWhereAdmin = useSelector(userGroupsWhereAdminSelector)
  const hasMoreUserGroups = useSelector(hasMoreUserGroupsSelector)
  const showHeader = !isFiltering || userGroupsWhereAdmin.length > 0

  return (
    <Group data-component="scope-dropdown-user-group-list">
      {showHeader && (
        <Header
          scope="user_group"
          showNewLink={canCreateNewGroups}
        />
      )}
      {userGroupsWhereAdmin.map(({ id, name, ...item }) => (
        <Item
          key={id}
          value={encodeScopeValue('user_group', id)}
          avatarLetter={item.avatar_letter}
          avatarUrl={item.avatar_url}
          filterTerm={filterTerm}
        >
          {name}
        </Item>
      ))}
      {hasMoreUserGroups && <ShowMore onClick={() => dispatch(loadMoreData('user_groups'))} />}
    </Group>
  )
}

export default UserGroupsList
